<template>
    <div>
        <title>总数</title>
        <article class="cardArticle">
            <header class="tabHeader">
                <p>
                    <router-link :to="{path:'/OperateRecord'}" v-if="openStoreDefinition==1">定义激活记录</router-link>
                    <router-link :to="{path:'/ActivationRecord'}">激活记录</router-link>
                    <router-link :to="{path:'/PauseRecord'}" class="isActive" >暂停记录</router-link>
                    <router-link :to="{path:'/ReuseRecord'}" >恢复记录</router-link>
                    <router-link :to="{path:'/RecoverRecord'}" v-if="ElementControls('erjimendian')==1">销售回收记录</router-link>
                    <router-link :to="{path:'/SpreadRecordMd'}"  v-if="ElementControls('erjimendian')==1">铺券记录</router-link>
                </p>
            </header>
            <main class="cardMain">
                <!-- S 检索 -->
                    <el-form :model="totalForm" :inline="true" class="searchForm totalForm">
                        <el-form-item label="券卡编码" class="codeSerIpt">
                            <el-input clearable v-model="totalForm.code" placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <!--<el-form-item label="状态">
                            <el-select v-model="totalForm.state" placeholder="请选择" clearable>
                                <el-option label="未激活" value="0"></el-option>
                                <el-option label="未提货" value="1"></el-option>
                                <el-option label="部分提货" value="2"></el-option>
                                <el-option label="已提货" value="3"></el-option>
                                <el-option label="已回收" value="5"></el-option>
                                <el-option label="重新出库" value="7"></el-option>
                                <el-option label="已暂停使用" value="4"></el-option>
                                <el-option label="已作废" value="6"></el-option>
                            </el-select>
                        </el-form-item>-->
                        <el-form-item>
                            <el-button type="primary" @click="query">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" plain @click="goBack">返回</el-button>
                        </el-form-item>
                        <p class="greyColor totalMsg"><i class="iconbulb"></i>已有<b class="commonNum">{{Number(this.$route.query.opernum)-cardBatchStatistics}}</b>张券卡被重新出库或者循环暂停使用！</p>
                    </el-form>
                    <!-- E 检索 -->
                <section class="totalCon">
                    <!-- S 表格 -->
                    <el-table ref="gsTable" class="comTable totalTable" border v-loading="vloading" :data="cardBatchCodeList" :maxHeight="tableHeight">
                        <el-table-column fixed label="序号" type="index"></el-table-column>
                        <el-table-column label="券卡编码" fixed min-width="200" sortable prop="code">
                            <template slot-scope="scope">
                                <p>{{scope.row.code ||'--'}}</p>
                                <em v-if="scope.row.serial">【{{scope.row.serial}}】</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="当前状态" min-width="120" fixed sortable prop="state">
                            <template slot-scope="scope">
                                <span class="orangeColor" v-if="scope.row.state == 0 || scope.row.state == 1">{{scope.row.state | cardStateFilter}}</span>
                                <span class="greenColor" v-if="scope.row.state == 2 || scope.row.state == 3">{{scope.row.state | cardStateFilter}}</span>
                                <span class="greyColor" v-if="scope.row.state == 4 || scope.row.state == 5|| scope.row.state == 6|| scope.row.state == 7|| scope.row.state == 8">{{scope.row.state | cardStateFilter}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="付款状态" min-width="120" fixed sortable prop="paystatus">
                            <template slot-scope="scope">
                                {{scope.row.paystatus | cardPpayStateFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡类型" sortable prop="cardkind" min-width="100">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.cardkind">{{scope.row.cardkind ||'--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="定义类型" sortable prop="deftype" min-width="180">
                            <template slot-scope="scope">
                                {{scope.row.deftype | cardTypeFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡流向" min-width="150">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.flowname" v-show="scope.row.deftype==0 || scope.row.deftype==3">{{scope.row.flowname || '--'}}</p>
                                <p class="textHiden" :title="scope.row.lflowname" v-show="scope.row.deftype==2">{{scope.row.lflowname || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="专区数量" sortable prop="selzones" min-width="100">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.selzones||'--'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="共可选择商品数" sortable prop="selnum" min-width="200">
                            <template slot-scope="scope">
                                <p class="flexUpDownCenter">
                                    <template v-if="scope.row.cardcategory===0">
                                        <span class="priceFont pr10" >{{scope.row.goodspicknum|| '--'}}</span>
                                        <el-tag type="danger" plain>定量组合提货卡</el-tag>
                                    </template>
                                    <template v-else-if="scope.row.cardcategory===1">
                                        <span class="priceFont pr10" >{{scope.row.goodspicknum|| '--'}}</span>
                                        <el-tag  type="warning" plain>套餐组合提货卡</el-tag>
                                    </template>
                                    <template v-else-if="scope.row.cardcategory===2">
                                        <span class="priceFont pr10" >{{scope.row.goodspicknum|| '--'}}</span>
                                        <el-tag  type="success" plain>定额组合提货卡</el-tag>
                                    </template>
                                    <template v-else>
                                        <span class="priceFont pr10" >{{scope.row.selnum|| '--'}}</span>
                                    </template>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="可使用次数" sortable prop="usenum" min-width="120">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.usenum || '0'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="默认商品" sortable prop="defaultgoodsname" min-width="200">
                            <template slot-scope="scope">
                                <p class="textHiden" v-if="String(scope.row.cardcategory)>=0">--</p>
                                <p class="textHiden" v-else :title="scope.row.defaultgoodsname">{{scope.row.defaultgoodsname || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡面值 (￥)" sortable prop="cardprice" min-width="130">
                           <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.cardprice | formatAmount}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column :label="ElementControls('Quota_Pickupcard')==1?'券卡面值/额度(￥)':'券卡面值(￥)'" min-width="170">
                             <template slot-scope="scope">
                                <em class="priceFont" v-show="scope.row.lcardsmallprice!==''&&scope.row.lcardsmallprice!==null">{{scope.row.lcardsmallprice | formatAmount}}</em>
                                <p class="textHiden left" v-show="scope.row.lcardsmallprice===''||scope.row.lcardsmallprice===null">--</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="有效期" sortable prop="startvaldate" min-width="120">
                            <template slot-scope="scope">
                                 <p class="serial" v-if="scope.row.startvaldate">
                                      {{dateTime(scope.row.startvaldate)}}
                                    <em>~</em>
                                      {{dateTime(scope.row.endvaldate)}}
                                </p>
                                <p class="serial" v-else>
                                      长期有效
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="客服备注" min-width="150">
                            <template slot-scope="scope">
                                <p class="textHiden left" :title="scope.row.sermemo">{{scope.row.sermemo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="面单打印备注" min-width="150">
                            <template slot-scope="scope">
                                <p class="textHiden left" :title="scope.row.printmemo">{{scope.row.printmemo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" fixed="right">
                            <template slot-scope="scope">
                                <a href="javascript:;" @click="getCoverDetailShow(scope.row.code)" class="icondetails" title="详情"></a>
                            </template>
                        </el-table-column>
                        <template slot="empty">
                  <div class="noData"><span>暂无数据</span></div>
                </template>
                    </el-table>
                    <!-- E 表格 -->
                </section>
                <!-- S 出库详情弹框 -->
                <OutDetail :cardInfo="cardInfo" :outDetailDialogVisible="outDetailDialogVisible"  @closeChild="getCloseOutDetailCld"></OutDetail>
                <!-- E 出库详情弹框 -->
                <!-- S 分页 -->
                  <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
                <!-- E 分页 -->
            </main>
        </article>
        
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
export default {
    name:'CardRecordTotal',
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
      OutDetail: resolve => require(["@/components/CardsFolder/OutDetail.vue"], resolve),//出库详情弹框
    },
    filters:{
        // 券卡当前状态
        stateFilter(val){
            if(val == 0){
                return '未激活'
            }else if(val == 1){
                return '未提货'
            }else if(val == 2){
                return '部分提货'
            }else if(val == 3){
                return '已提货'
            }else if(val == 4){
                return '已回收'
            }else if(val == 5){
                return '重新出库'
            }else if(val == 6){
                return '已暂停使用'
            }else if(val == 7){
                return '已作废'
            }
        }
    },
    data(){
        return{
            vloading:false,
            openStoreDefinition:0,
            cardInfo:'',
            batchcode:'',
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            cardBatchStatistics:0,
            cardBatchCodeList:[],
            // 检索表单
            totalForm:{
                code:'',//关键词
                state:'',//状态
            },
            // 表格数据
            recordData:[{
                serial:'aa005837',
                code:'9998573969214505',
                state:0
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:1
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:2
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:3
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:4
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:5
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:6
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:7
            }],
            outDetailDialogVisible:false,//出库详情弹框
            totalIndex:-1,//当前选中总数
            totalData:[
                {
                    num:10,
                    totalText:'总数'
                },{
                    num:1,
                    totalText:'未激活'
                },{
                    num:1,
                    totalText:'未提货'
                },{
                    num:1,
                    totalText:'部分提货'
                },{
                    num:1,
                    totalText:'已提货'
                },{
                    num:1,
                    totalText:'已回收'
                },{
                    num:1,
                    totalText:'重新出库'
                },{
                    num:1,
                    totalText:'已暂停使用'
                },{
                    num:1,
                    totalText:'已作废'
                }
            ],
            tableHeight: window.innerHeight*.8, //表格动态高度
        }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    // ==================================== 方法 ====================================
    methods:{
        //查询
        query(){
          this.pageSize =30;
          this.currentPage =1;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 分页
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 打开出库详情弹框
        getCoverDetailShow(code){
            Api.GET_CARDINFODET({code:code,opertype:2}).then(res =>{
               if(res.data.status=="200"){
                  if(res.data.data.codeinfo){
                    this.cardInfo = res.data.data.codeinfo;
                    this.outDetailDialogVisible = true;
                  }
               }
            })
        },
        // 关闭出库详情弹框
        getCloseOutDetailCld(){
            this.outDetailDialogVisible = false;
        },
        // 切换各种状态
        getTotalTab(totalIndex){
            this.totalIndex = totalIndex;
            if(totalIndex==-1){
              this.totalForm.state = '';
            }else{
              this.totalForm.state = totalIndex;
            }
            this.pageSize = 30;
            this.currentPage = 1;
            this.totalForm.code ='';
            this.getCardBatchCodeList();
        },
        // 返回上一页
        goBack(){
            window.history.back();   
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 125; 
        },
        // 数量使用情况
        getCardBatchStatistics(){
           let param = {
              batchcode:this.batchcode,
              codetype:0
            }
          Api.TOTALCODESUBNUM(param).then(res =>{
            if(res.data.status=="200"){
              this.cardBatchStatistics = res.data.data;
            }else{
              this.cardBatchStatistics= 0;
            }
          })
        },
        // 批次内编码详情列表
        getCardBatchCodeList(){
           let param = {
               batchcode:this.batchcode,
               opertype:2,
               code:this.totalForm.code,
               state:this.totalForm.state,
               pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                }
           }
           this.vloading = true;
          Api.GET_CARDBATCHCODELIST(param).then(res =>{
             if(res.data.status=="200"){
                this.vloading = false;
                this.cardBatchCodeList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
              }else {
                 this.vloading = false;
                 this.pageTotal =0;
                 this.cardBatchCodeList =[];
              }
          })
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        this.openStoreDefinition = this.ElementControls('openStoreDefinition')
        if(this.$route.query.batchcode){
          this.batchcode = this.$route.query.batchcode;
          this.getCardBatchCodeList();
          this.getCardBatchStatistics();
        }
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.cardArticle{
    position: relative;
    padding: 84px 20px 20px 20px;
    height: calc(100% - 169px);
}
/* S 头部数量统计 */
.cardMain>>>.tabHeader{
    top: 115px;
    height: auto;
    background: none;
}
.totalHead{
    width: 100%;
    height: 100px;
    background: #F5F7FA;
} 
.totalHead li{
    position: relative;
    text-align: center;
    width: 11.1%;
    cursor: pointer;
}
.totalHead li::after{
    content: '';
    position: absolute;
    width: 1px;
    height: 60px;
    background: #DCDFE6;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 0;
}
.totalHead li:last-child::after{
    display: none;
}
.totalHead li strong{
    color: #333;
    font-size: 28px;
    font-family: "PingFang SC", "Microsoft YaHei", Arial, Verdana;
} 
.totalHead li em{
    color: #666;
    display: block;
    margin-top: 5px;
} 
.totalHead .active strong{
    font-weight: bold;
}
/* E 头部数量统计 */
/* S 检索 */
.totalMsg{
    font-size: 12px;
    display: inline-block;
    line-height: 40px;
    border: none;
    width: auto;
}
.totalMsg i{
    color: #F2962C;
    font-size: 16px;
    margin-right: 5px;
}
.totalMsg b{
    color: #F7615E;
    font-weight: bold;
    margin: 0 3px;
    font-size: 14px;
}
/* E 检索 */
/* S 表格 */
.totalTable tr:last-child td{
    border-bottom: none;
}
.totalTable>>>th:last-child .cell,
.totalTable>>>td:last-child .cell,
.totalTable>>>th:first-child .cell,
.totalTable>>>td:first-child .cell{
    text-align: center;
}
.totalTable>>>.el-table__fixed-right-patch{
    background-color: #F5F7FA;
}
.serial em{
    display: block;
    margin-left: 26px;
}
.totalTable .icondetails{
    font-size: 18px;
}
/* E 表格 */
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardRecord/PauseRecordTotal.vue